import React, { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import styles from '../pages/Shipturtle.module.css';
import { getCurrentUserRole } from '../services/shipturtleApi';

function ShipturtleHeader() {
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const fetchRole = async () => {
      try {
        const roleData = await getCurrentUserRole();
        setUserRole(roleData?.role);
      } catch (err) {
        console.error('Error fetching user role:', err);
      }
    };
    fetchRole();
  }, []);

  return (
    <div className={styles.header}>
      <Link to="/suspire-terminal" className={styles.logoLink} aria-label="Suspire Terminal home">
        <img src="/images/feature-headers/suspire-terminal.png" alt="Suspire Terminal" className={styles.logo} style={{ width: 'auto', height: '56px' }} />
      </Link>
      <div className={styles.subNav}>
        <NavLink
          to="/suspire-terminal/orders"
          className={({ isActive }) => `${styles.subNavButton} ${isActive ? styles.active : ''}`}
        >
          Orders
        </NavLink>
        <NavLink
          to="/suspire-terminal/products"
          className={({ isActive }) => `${styles.subNavButton} ${isActive ? styles.active : ''}`}
        >
          Products
        </NavLink>
        <NavLink
          to="/suspire-terminal/vendors"
          className={({ isActive }) => `${styles.subNavButton} ${isActive ? styles.active : ''}`}
        >
          Vendors
        </NavLink>
        {userRole === 'admin' && (
          <NavLink
            to="/suspire-terminal/vendor-store"
            className={({ isActive }) => `${styles.subNavButton} ${isActive ? styles.active : ''}`}
          >
            Vendor Store
          </NavLink>
        )}
        {/* Admin-only: every B2B endpoint is IsAdmin-gated, so showing this to a
            vendor would only lead them to a redirect. */}
        {userRole === 'admin' && (
          <NavLink
            to="/suspire-terminal/b2b-orders"
            className={({ isActive }) => `${styles.subNavButton} ${isActive ? styles.active : ''}`}
          >
            B2B Orders
          </NavLink>
        )}
        <NavLink
          to="/suspire-terminal/faq"
          className={({ isActive }) => `${styles.subNavButton} ${isActive ? styles.active : ''}`}
        >
          FAQ &amp; Resources
        </NavLink>
      </div>
    </div>
  );
}

export default ShipturtleHeader;


